import { getTelehealthConfig } from '../../config';

export const MAX_TWILIO_WEBSOCKET_CONNECTION_RETRIES_BEFORE_FALLBACK_KEY =
  'max_twilio_websocket_connection_retries_before_fallback';

/**
 * Retrieves the maximum number of Twilio websocket connection retries to allow
 * before falling back to the Telehealth systems reverse proxy, configured externally
 * in Statsig. The fallback mechanism is necessary when a user's network blocks
 * the Twilio Sync/Conversations websocket endpoint, in which case we need to fall
 * back to the Telehealth systems reverse proxy on the Telehealth domain.
 */
export function getMaxTwilioWebsocketConnectionRetriesBeforeFallback(
  options?: Parameters<typeof getTelehealthConfig>[0],
) {
  return getTelehealthConfig(options).max_twilio_websocket_connection_retries_before_fallback;
}
